module.exports = __webpack_public_path__ + "static/media/buffl.902544a2.svg";